import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(170px, 1fr))',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(2),
    },
    card: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
        padding: theme.spacing(1.5, 1.75),
        border: '1px solid var(--dm-border, #dbe2ea)',
        borderRadius: 8,
        backgroundColor: 'var(--contentColor, #ffffff)',
        textAlign: 'left',
        transition: 'border-color 150ms ease, box-shadow 150ms ease',
        '&:hover': {
            borderColor: theme.palette.primary.main,
        },
    },
    cardActive: {
        borderColor: theme.palette.primary.main,
        boxShadow: '0 0 0 3px rgba(61, 125, 221, 0.14)',
    },
    label: {
        color: 'var(--dm-muted, #647184)',
        fontSize: '0.75rem',
        fontWeight: 600,
        lineHeight: 1.35,
    },
    value: {
        marginTop: theme.spacing(0.5),
        color: 'var(--dm-text-strong, #1f2f4a)',
        fontSize: '1rem',
        fontWeight: 700,
    },
    valueFull: {
        color: '#9b2c2c',
    },
    detail: {
        marginTop: 2,
        color: 'var(--dm-muted, #8a96a5)',
        fontSize: '0.6875rem',
    },
}));

const CapacityCards = ({ summary, activeType, onSelect }) => {
    const classes = useStyles();
    return (
        <div className={classes.grid} role="group" aria-label="Licence capacity by category">
            {summary.filter(item => item.count > 0).map(item => (
                <ButtonBase
                    key={item.type}
                    className={`${classes.card}${activeType === item.type ? ` ${classes.cardActive}` : ''}`}
                    onClick={() => onSelect(activeType === item.type ? 'all' : item.type)}
                    aria-pressed={activeType === item.type}
                >
                    <span className={classes.label}>{item.label}</span>
                    <span className={`${classes.value}${item.remaining <= 0 ? ` ${classes.valueFull}` : ''}`}>
                        {item.remaining} of {item.allocated} left
                    </span>
                    <span className={classes.detail}>
                        {item.count} licence{item.count === 1 ? '' : 's'} in this project
                    </span>
                </ButtonBase>
            ))}
        </div>
    );
};

export default CapacityCards;
